export const LIST_EMPLOYEE = 'LIST_EMPLOYEE'
export const DETAIL_EMPLOYEE = 'DETAIL_EMPLOYEE'
